module.exports = __webpack_public_path__ + "static/media/icon10-1.8cecc205.png";